var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1376 13.6329L11.2954 6.22504H9.11471L6.25615 13.6329L3.3976 6.22504H0L5.00656 19.2519H7.18722L10.1928 11.493L13.2147 19.2519H15.3954L20.3856 6.22504H17.0125L14.154 13.6329H14.1376Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9924 5.69259C26.5387 5.69259 25.2156 6.13366 24.0967 6.88499V0H20.9849V12.6919C20.9849 16.5552 24.1293 19.6668 27.9761 19.6668C31.8229 19.6668 35 16.5797 35 12.6593C35 8.73901 31.8882 5.68447 27.9924 5.68447V5.69259ZM27.9761 16.5552C25.869 16.5552 24.0967 14.8727 24.0967 12.6757C24.0967 10.4787 25.7628 8.81248 27.9924 8.81248C30.2221 8.81248 31.8882 10.5522 31.8882 12.6757C31.8882 14.7991 30.1159 16.5552 27.9761 16.5552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67921412f5d7ca3a825400c3f7a407ec.svg";
export { ForwardRef as ReactComponent };